import { staffPath } from "../../lib/hosting";
import { buildCentralCaseWorkspacePath } from "../../lib/central-case-context";

export const arrangementRoutes = {
  start: "/arrangements/start",
  studio: "/arrangements/studio",
  confirmation: "/arrangements/confirmation",
  get admin() {
    return staffPath("/admin");
  },
  get director() {
    return staffPath("/admin");
  },
  directorCase: (caseId: string) => staffPath(`/admin${buildCentralCaseWorkspacePath("case-overview", caseId)}`),
  statement: (caseId: string) => staffPath(`/admin/cases/${caseId}/statement`),
  get system() {
    return staffPath("/admin/workspace");
  },
  systemPage: (screenId: string) => staffPath(`/admin/workspace/${screenId}`),
  memorialHub: (caseId: string) => `/memorial-hub/${caseId}`,
};
